module.exports = __webpack_public_path__ + "img/data_layers.619f2316.svg";